import React from 'react';
import classNames from 'classnames';
import autosize from 'autosize';
import LinkButton from 'components/shared/LinkButton';
import { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import { Icon } from 'ui';
import request from 'utils/request_ajax.js';
import { routes } from 'constants/config';
import addModifiers from 'utils/add_modifiers';
import Tooltip from 'components/shared/Tooltip';

class ScenarioDescription extends React.Component {
  state = {
    isEditing: false,
    scenarioDescription: this.props.scenario.description,
    loading: false,
  };

  inputRef = React.createRef();

  focusInputRef() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  componentDidMount() {
    if (this.inputRef.current) {
      autosize(this.inputRef.current);
    }
  }

  sizeElement = () => {
    if (this.inputRef.current) {
      autosize(this.inputRef.current);
    }
  };

  updateElementSize = () => {
    if (this.inputRef.current) {
      autosize.update(this.inputRef.current);
    }
  };

  cancelEditing = () => {
    this.setState({
      isEditing: false,
      scenarioDescription: this.props.scenario.description,
    });
  };

  startEditing = () => {
    this.setState(
      {
        isEditing: true,
      },
      () => {
        this.focusInputRef();
        this.sizeElement();
      },
    );
  };

  changeDescription = e => {
    this.setState(
      {
        scenarioDescription: e.target.value.replace(/[\r\n|\n|\s]+/g, ' '),
      },
      () => {
        this.updateElementSize();
      },
    );
  };

  handleKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.setState({ shake: true });
      setTimeout(() => {
        this.setState({ shake: false });
      }, 500);
    }
  };

  updateDescription = () => {
    this.setState({
      loading: true,
    });
    const { scenarioDescription } = this.state;
    const scenarioData = {
      scenario: {
        description: scenarioDescription,
      },
    };
    request
      .put(
        routes.ON_DEMAND_PRACTICE.CREATOR.UPDATE(this.props.scenario.id),
        scenarioData,
      )
      .then(data => {
        if (data.success) {
          this.props.updateScenario(data.scenario);
          this.setState({
            loading: false,
            isEditing: false,
          });
        }
      });
  };

  render() {
    const { scenario, userCanEditScenario } = this.props;
    const { isEditing, scenarioDescription, loading, shake } = this.state;

    const textAreaClassName = classNames('Textarea w-fill', {
      Animated: true,
      'Animated--shake': shake,
    });
    return (
      <>
        <div className="d-f jc-sb ai-fs">
          <SectionHeader>
            {t('practice.on_demand_practice.overview.description_title')}
          </SectionHeader>
          {!isEditing && userCanEditScenario && (
            <Tooltip
              align="end"
              text={
                scenario.archived &&
                t('practice.on_demand_practice.overview.archived_note')
              }
            >
              <LinkButton
                className="u-linkBtn"
                type="primary"
                onClick={this.startEditing}
                disabled={scenario.archived}
              >
                <Icon name="edit" className="mr-4" />
                {t('common.edit')}
              </LinkButton>
            </Tooltip>
          )}
        </div>
        {!isEditing && scenario.description && (
          <p className="m-0 ws-pr">{scenario.description}</p>
        )}
        {!scenario.description && !isEditing && (
          <span className="c-brand-gray-darker">No Description</span>
        )}
        {isEditing && (
          <div>
            <textarea
              className={textAreaClassName}
              value={scenarioDescription || ''}
              onChange={this.changeDescription}
              onKeyDown={this.handleKeyDown}
              ref={this.inputRef}
            />
            <div className="d-f jc-e ai-c mt-8">
              <button
                type="button"
                className="u-linkBtn u-linkBtn--dark td-u"
                onClick={this.cancelEditing}
              >
                {t('common.cancel')}
              </button>
              <button
                type="button"
                className={`ml-16 ${addModifiers('NewButton', [
                  'blue',
                  'wide',
                  'center',
                ])}`}
                onClick={this.updateDescription}
              >
                {loading && <span className="Spinner mr-4" />}
                {!loading && t('common.save')}
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default ScenarioDescription;
